















import { Component, Vue } from 'vue-property-decorator';
import TeamForm from './teamForm.vue';
import { teamManage } from '../team';
import EditMembers from './editMembers.vue';
import EditUsers from '../../components/editUsers.vue';


@Component({
  components: {
    TeamForm,
    EditMembers,
    EditUsers,
  },
})
export default class TeamModal extends Vue {
  private componentName = 'team-form';
  private type = 'add';
  private visible = false;
  private title = this.$t('team.editTeam').toString();
  private managers: IUser.IResponse.IUserDetailInfo[] = [];
  public showModal(component = 'team-form', type: 'add' | 'del' = 'add') {
    this.visible = true;
    this.componentName = component;
    if (component === 'edit-members') {
      this.type = type;
      this.title = this.$t('team.updateMember').toString();
      return;
    }
    if (component === 'edit-managers') {
      this.type = type;
      this.title = this.$t('team.updateManager').toString();
      this.managers = teamManage.editData.teamInfo?.manager || [];
      return;
    }
    if (teamManage.editData.isCreate) {
      this.title = this.$t('team.createTeam').toString();
    } else {
      this.title = this.$t('team.editTeam').toString();
    }
  }
  public addManagers(managerIds: string[]): Promise<string> {
    return teamManage.requestAddManagers(managerIds);
  }
  public deleteManagers(managerIds: string[]): Promise<string> {
    return teamManage.requestDeleteManagers(managerIds);
  }
}
